import type { ReactNode } from 'react';
import { cn } from '../ui/utils';

type EmptyStateProps = {
    message: string;
    action?: ReactNode;
    className?: string;
};

function EmptyState({ message, action, className }: EmptyStateProps) {
    return (
        <div className={cn('nx-empty', className)}>
            <p>{message}</p>
            {action}
        </div>
    );
}

export { EmptyState };
export type { EmptyStateProps };
